import { createFileRoute } from '@tanstack/react-router';
import { CampaignExperimentsRoute } from './-route-wrappers';

function CampaignTestsRoute() {
  const { campaignId } = Route.useParams();
  return <CampaignExperimentsRoute campaignId={campaignId} campaignPath="campaigns" />;
}

export const Route = createFileRoute('/_authenticated/workspaces/$workspaceId/campaigns/$campaignId/overview/tests/')({
  component: CampaignTestsRoute,
});
